export const formatDate = (dateString: string): string => {
  return new Date(dateString).toLocaleString();
};

export const formatTimeAgo = (date: Date | null): string => {
  if (!date) return 'Never';
  
  const seconds = Math.floor((new Date().getTime() - date.getTime()) / 1000);
  if (seconds < 60) return 'Just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  return `${hours}h ago`;
};

export const formatIpAddress = (ip: string): string => {
  if (!ip) return 'N/A';
  
  // Remove IPv6-mapped IPv4 prefix
  const cleaned = ip.replace(/^::ffff:/i, '');
  
  // Convert IPv6 loopback to IPv4 loopback
  if (cleaned === '::1' || cleaned === '0:0:0:0:0:0:0:1') {
    return '127.0.0.1';
  }
  
  // If it's still an IPv6 address (contains colons), try to extract IPv4 from it
  if (cleaned.includes(':') && cleaned.includes('.')) {
    // Extract the last part which might be IPv4
    const parts = cleaned.split(':');
    const lastPart = parts[parts.length - 1];
    if (/^\d+\.\d+\.\d+\.\d+$/.test(lastPart)) {
      return lastPart;
    }
  }
  
  // If it's a pure IPv6 address, return as is (or you could format it better)
  if (cleaned.includes(':') && !cleaned.includes('.')) {
    // For pure IPv6, you might want to show it differently
    // For now, return it as is
    return cleaned;
  }
  
  return cleaned;
};

export const isDeviceOnline = (lastSeen: string): boolean => {
  const timeSinceLastSeen = new Date().getTime() - new Date(lastSeen).getTime();
  return timeSinceLastSeen < 60000; // Online if seen in last minute
};

export const calculateConnectionRate = (
  totalConnections: number,
  totalPhones: number
): number => {
  if (totalPhones === 0) return 0;
  return Math.round((totalConnections / totalPhones) * 100);
};

